import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Tooltip.scss';

export const positions = [
    'top',
    'top-left',
    'top-left-corner', // TODO: currently only works with FixedTooltip
    'top-right',
    'top-right-corner', // TODO: currently only works with FixedTooltip
    'bottom',
    'bottom-left',
    'bottom-left-corner', // TODO: currently only works with FixedTooltip
    'bottom-right',
    'bottom-right-corner', // TODO: currently only works with FixedTooltip
    'left',
    'left-top',
    'left-bottom',
    'right',
    'right-top',
    'right-bottom',
];

export const themes = ['action', 'default', 'danger', 'alert', 'plain', 'success'];

const TooltipClassName = 'cc-tooltip';
const TooltipContentClassName = `${TooltipClassName}__content`;
export const TooltipContentPopupClassName = `${TooltipContentClassName}-popup`;

// Use this when you need to apply the Tooltip class to your own element.
export const getTooltipClassName = ({ className, hasPointer, isExpanded, position }) => {
    return classNames(
        className,
        TooltipClassName,
        `${TooltipClassName}--pos-${position || 'top'}`,
        { [`${TooltipClassName}--pointer`]: hasPointer },
        { [`${TooltipClassName}--expanded`]: isExpanded },
    );
};

export const Tooltip = ({ children, className, hasPointer, isExpanded, position = 'top' }) => {
    const containerClasses = getTooltipClassName({ position, hasPointer, isExpanded, className });

    return <span className={containerClasses}>{children}</span>;
};

Tooltip.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    isExpanded: PropTypes.bool,
    position: PropTypes.oneOf(positions),
};

export const TooltipContent = ({
    children,
    className,
    isAnimated = false,
    isContentCentered,
    hasBorder,
    hasSetWidth,
    popupClassName,
    theme = 'default',
}) => {
    const containerClasses = classNames(className, TooltipContentClassName, {
        [`${TooltipContentClassName}--animated`]: isAnimated,
    });
    const popupClasses = classNames(
        popupClassName,
        `${TooltipContentPopupClassName}`,
        { [`${TooltipContentPopupClassName}--bordered`]: hasBorder },
        { [`${TooltipContentPopupClassName}--set-width`]: hasSetWidth },
        { [`${TooltipContentPopupClassName}--centered`]: isContentCentered },
        `${TooltipContentPopupClassName}--theme-${theme}`,
    );

    return (
        <span className={containerClasses}>
            <div className={popupClasses}>{children}</div>
        </span>
    );
};

TooltipContent.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    isContentCentered: PropTypes.bool,
    isAnimated: PropTypes.bool,
    hasBorder: PropTypes.bool,
    hasSetWidth: PropTypes.bool,
    popupClassName: PropTypes.string,
    theme: PropTypes.oneOf(themes),
};

export const TooltipText = ({
    children,
    className,
    isBlue,
    isEmphasized,
    wrapperElement = 'p',
}) => {
    const WrapperElement = wrapperElement;

    return (
        <WrapperElement
            className={classNames(
                className,
                'tooltip__text',
                { 'tooltip__text--emphasized': isEmphasized },
                { 'tooltip__text--blue': isBlue },
            )}
        >
            {children}
        </WrapperElement>
    );
};

TooltipText.propTypes = {
    className: PropTypes.string,
    isBlue: PropTypes.bool,
    isEmphasized: PropTypes.bool,
};

export const TooltipTextGroup = ({ children, isDivided }) => (
    <div
        className={classNames('tooltip__text-group', {
            'tooltip__text-group--divided': isDivided,
        })}
    >
        {children}
    </div>
);
